<template>
  <div class="form-group">
    <slot></slot>
    <label v-if="label" :for="for" class="floating-label">{{ label }}</label>
    <div v-if="description" class="field-description">{{ description }}</div>
    <div v-if="error" class="form-error">{{ error }}</div>
  </div>
</template>

<script>
export default {
  name: 'FormGroup',
  props: {
    label: String,
    for: String,
    description: String,
    error: String
  }
};
</script>

<style>
.form-group {
  position: relative;
  margin: var(--padding-modal);

  input,
  select,
  textarea {
    font-family: var(--font-family);
    width: 100%;
    padding: var(--padding-modal);
    border: 1px solid var(--color-border);
    border-radius: var(--border-radius);
    background: var(--color-sidebar-bg);
    color: var(--color-text);
    outline: none;
    box-sizing: border-box;
  }

  /* Toggle button styles for checkboxes */
  input[type='checkbox'] {
    appearance: none;
    width: 44px;
    height: 24px;
    background: var(--color-border);
    border-radius: 12px;
    position: relative;
    cursor: pointer;
    transition: background var(--transition);
    border: none;
    padding: 0;
    vertical-align: middle;
    margin-top: 10px;

    &:checked {
      background: var(--color-primary);
    }

    &::before {
      content: '';
      position: absolute;
      width: 18px;
      height: 18px;
      border-radius: 50%;
      background: white;
      top: 3px;
      left: 3px;
      transition: transform var(--transition);
      box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
    }

    &:checked::before {
      transform: translateX(20px);
    }
  }

  label.floating-label {
    position: absolute;
    left: 12px;
    top: 16px;
    color: var(--color-text);
    background: var(--color-sidebar-bg);
    padding: 0 4px;
    pointer-events: none;
    transition: var(--transition);
    z-index: 2;
  }

  input:focus + label.floating-label,
  input:not(:placeholder-shown) + label.floating-label,
  textarea:focus + label.floating-label,
  textarea:not(:placeholder-shown) + label.floating-label {
    top: -10px;
    left: 8px;
  }

  .field-description {
    position: absolute;
    right: 0;
    top: -14px;
    pointer-events: none;
    opacity: 0;
    transform: translateY(10px);
    transition:
      opacity var(--transition),
      transform var(--transition);
    z-index: 1;
    display: block;
  }
  input:focus ~ .field-description,
  textarea:focus ~ .field-description {
    opacity: 0.6;
    transform: translateY(0);
  }
}
</style>
